import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, Button, Box, Typography
} from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { LoadingButton } from '@mui/lab';

export function DenyDialog({
  open,
  remark,
  setRemark,
  files,
  setFiles,
  onRemoveFile,
  saving,
  onClose,
  onSubmit
}) {
  const handleFileChange = (e) => {
    const selected = Array.from(e.target.files || []);
    if (selected.length) setFiles(prev => [...prev, ...selected]);
  };

  return (
    <Dialog open={open} onClose={!saving ? onClose : undefined}>
      <DialogTitle>拒絕轉貨紀錄</DialogTitle>

      <DialogContent>
        <Typography sx={{ mb: 1 }}>
          請輸入拒絕原因，可選擇加入圖片作證。
        </Typography>

        <TextField
          label="拒絕原因（必填）"
          fullWidth
          multiline
          minRows={3}
          value={remark}
          onChange={(e) => setRemark(e.target.value)}
        />

        <Box sx={{ mt: 2 }}>
          <Button component="label" variant="outlined">
            上載圖片
            <input hidden type="file" multiple accept="image/*" onChange={handleFileChange} />
          </Button>
        </Box>

        {files.length > 0 && (
          <Box sx={{ mt: 2, display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            {files.map((file, idx) => {
              const url = URL.createObjectURL(file);
              return (
                <Box key={idx} sx={{ position: 'relative' }}>
                  <CancelIcon
                    onClick={() => onRemoveFile(idx)}
                    sx={{
                      position: 'absolute',
                      top: -10,
                      right: -10,
                      cursor: 'pointer',
                      color: 'red',
                    }}
                  />
                  <img src={url} alt="" width={120} />
                </Box>
              );
            })}
          </Box>
        )}
      </DialogContent>

      <DialogActions>
        <Button disabled={saving} onClick={onClose}>取消</Button>
        <LoadingButton loading={saving} variant="contained" color="error" onClick={onSubmit}>
          確認拒絕
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
